export default __webpack_public_path__ + "static/media/LENS_ERVOIDES_TEKAY_complete_5.e6e10844.jpg";